import { createSelector } from 'reselect';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

function filterBySlug(data, slug) {
  if (_isEmpty(data)) return {};
  return data.filter(el => el.slug === slug)[0];
}

const selectMainDomain = state => state.main;

const makeSelectProcessing = () =>
  createSelector(
    selectMainDomain,
    substate => substate.processing,
  );

const makeSelectClientDetails = () =>
  createSelector(
    selectMainDomain,
    substate => substate.clientDetails,
  );

const makeSelectAllowSignIn = () =>
  createSelector(
    selectMainDomain,
    substate => {
      const allowSignIn = _get(substate.clientDetails, ['allowSignIn']);

      if (allowSignIn !== undefined) return allowSignIn;
      return true;
    },
  );

const makeSelectOAuthOptions = () =>
  createSelector(
    selectMainDomain,
    substate => {
      const msAllowed = _get(substate.clientDetails, ['msOAuthSignIn']);
      const googleAllowed = _get(substate.clientDetails, ['googleSignIn']);
      const facebookAllowed = _get(substate.clientDetails, ['facebookSignIn']);
      const cmAllowed = _get(substate.clientDetails, ['cmSignIn']);

      const options = {
        ms: msAllowed !== undefined ? msAllowed : true,
        google: googleAllowed !== undefined ? googleAllowed : true,
        facebook: facebookAllowed !== undefined ? facebookAllowed : true,
        cm: cmAllowed !== undefined ? cmAllowed : true,
      };

      return options;
    },
  );

const makeSelectShowingTermsOfUse = () =>
  createSelector(
    selectMainDomain,
    substate => substate.showingTermsOfUse,
  );

const makeSelectShowingPrivacyPolicy = () =>
  createSelector(
    selectMainDomain,
    substate => substate.showingPrivacyPolicy,
  );
const makeSelectShowingFeedback = () =>
  createSelector(
    selectMainDomain,
    substate => substate.showingFeedback,
  );

const makeSelectFooter = () =>
  createSelector(
    selectMainDomain,
    substate => filterBySlug(substate.siteCopy, 'footer'),
  );
const makeSelectHomeHero = () =>
  createSelector(
    selectMainDomain,
    substate => filterBySlug(substate.siteCopy, 'home-hero'),
  );
const makeSelectSendMailStatus = () =>
  createSelector(
    selectMainDomain,
    substate => substate.mailSent,
  );
const makeSelectHomeHeaders = () =>
  createSelector(
    selectMainDomain,
    substate => filterBySlug(substate.siteCopy, 'home-section-headers'),
  );
const makeSelectFavoritesHeaders = () =>
  createSelector(
    selectMainDomain,
    substate => filterBySlug(substate.siteCopy, 'favorites-section-headers'),
  );
const makeSelectPrivacyPolicy = () =>
  createSelector(
    selectMainDomain,
    substate => filterBySlug(substate.siteCopy, 'privacy'),
  );
const makeSelectTermsOfUse = () =>
  createSelector(
    selectMainDomain,
    substate => filterBySlug(substate.siteCopy, 'terms-of-use'),
  );
const makeSelectFeedback = () =>
  createSelector(
    selectMainDomain,
    substate => filterBySlug(substate.siteCopy, 'feedback'),
  );
const makeSelectSiteCopy = () =>
  createSelector(
    selectMainDomain,
    substate => substate.siteCopy,
  );

const makeSelectProgramsByTopic = () =>
  createSelector(
    selectMainDomain,
    substate => substate.programs,
  );
const makeSelectThemes = () =>
  createSelector(
    selectMainDomain,
    substate => substate.themes,
  );
const makeSelectResourcesCountByTopic = () =>
  createSelector(
    selectMainDomain,
    substate => substate.resourcesCountByTopic,
  );
const makeSelectClientDetailsFetching = () =>
  createSelector(
    selectMainDomain,
    substate => substate.clientDetailsFetching,
  );
const makeSelectClientResources = () =>
  createSelector(
    selectMainDomain,
    substate => substate.clientResources,
  );
const makeSelectShowRegionSelector = () =>
  createSelector(
    selectMainDomain,
    substate => substate.showRegionSelector,
  );
const makeSelectRegion = () =>
  createSelector(
    selectMainDomain,
    substate => substate.region,
  );
const makeSelectShowRegionBanner = () =>
  createSelector(
    selectMainDomain,
    substate => substate.showRegionBanner,
  );
const makeSelectLandingMenu = () =>
  createSelector(
    selectMainDomain,
    substate => substate.landingMenu,
  );
const makeSelectShowHomepagePro = () =>
  createSelector(
    selectMainDomain,
    substate => substate.showHomepagePro,
  );

export {
  makeSelectProcessing,
  makeSelectClientDetailsFetching,
  makeSelectClientDetails,
  makeSelectAllowSignIn,
  makeSelectOAuthOptions,
  makeSelectShowingTermsOfUse,
  makeSelectShowingPrivacyPolicy,
  makeSelectShowingFeedback,
  makeSelectFooter,
  makeSelectHomeHero,
  makeSelectSendMailStatus,
  makeSelectHomeHeaders,
  makeSelectFavoritesHeaders,
  makeSelectSiteCopy,
  makeSelectPrivacyPolicy,
  makeSelectTermsOfUse,
  makeSelectFeedback,
  makeSelectProgramsByTopic,
  makeSelectThemes,
  makeSelectResourcesCountByTopic,
  makeSelectClientResources,
  makeSelectShowRegionSelector,
  makeSelectRegion,
  makeSelectShowRegionBanner,
  makeSelectLandingMenu,
  makeSelectShowHomepagePro,
};
